import clsx from 'clsx';
import { X } from 'lucide-react';
import React, { ChangeEvent } from 'react';
import IconifyIcon from '../IconifyIcon/IconifyIcon';
import Spinner from '../Spinner';
import { Button } from '../ui/button';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  isLoading?: boolean;
}

export const SearchInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      helperText,
      isLoading = false,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={clsx('flex flex-col', className)}>
        <div
          className={clsx(
            'flex items-center h-10 w-full rounded-md border border-input bg-background text-sm ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
          )}
        >
          <span className='pl-3 text-sm text-muted-foreground'>
            <IconifyIcon name='material-symbols-light:search' size={24} color='#666666' />
          </span>
          <input
            type={type}
            className={clsx(
              'flex-1 px-3 py-2 rounded-md placeholder:text-muted-foreground focus:outline-none disabled:opacity-50 w-fit min-w-[150px]',
            )}
            ref={ref}
            {...props}
          />
          {isLoading ? (
            <span className='px-3 text-sm text-muted-foreground'>
              <Spinner width={24} height={24} />
            </span>
          ) : props.value ? (
            <span className='px-3 text-sm text-muted-foreground'>
              <Button
                className='p-0 h-fit'
                variant='ghost'
                onClick={() => {
                  props.onChange?.({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
                }}
              >
                <X size={20} />
              </Button>
            </span>
          ) : null}
        </div>
        {helperText && <span className='mt-1 text-xs text-muted-foreground'>{helperText}</span>}
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';
